import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "../_virtual/_rollupPluginBabelHelpers.js";
var AudioSample = /* @__PURE__ */ _createClass(
  function AudioSample2(pts, data, duration, sampleOffset) {
    _classCallCheck(this, AudioSample2);
    _defineProperty(this, "duration", 1024);
    _defineProperty(this, "flag", {
      dependsOn: 2,
      isNonSyncSample: 0
    });
    _defineProperty(this, "keyframe", true);
    this.originPts = this.pts = this.dts = pts;
    this.data = data;
    this.size = data.byteLength;
    this.sampleOffset = sampleOffset;
    if (duration)
      this.duration = duration;
  }
);
export { AudioSample };
